// eslint-disable-next-line
import React from 'react' // Needed for styled() Extends

import styled from 'styled-components'
import Info from 'svg/info.svg'
export const ArtworkImage = styled.div`
  position: relative;
  display: inline-block;
  background: #eeeeee;
  a {
    display: flex;
  }
  img {
    max-width: 100%;
    max-height: 100%;
    height: auto;
    width: auto;
    display: block;
    pointer-events: none;
  }

  [data-type='overlay'],
  [data-type='actions'] {
    position: absolute;
    opacity: 0;
    transition: 0.2s ease-in-out opacity;
  }

  [data-type='overlay'] {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.3);
    pointer-events: none;
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      display: none;
    }
  }

  [data-type='actions'] {
    top: 5px;
    right: 5px;
    display: flex;
    a + a {
      margin-left: 5px;
    }
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      display: none;
    }
  }

  &:hover {
    [data-type='overlay'],
    [data-type='actions'] {
      opacity: 1;
    }
  }
`
export const ArtworkText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  a {
    display: block;
    color: #333333;
    text-decoration: none;
    :hover {
      color: #000000;
    }
  }

  [data-type='country'] {
    color: #666666;
  }

  [data-type='prints'],
  [data-type='sold'] {
    color: #999999;
    a {
      color: #999999;
      :hover {
        color: #333333;
      }
      text-decoration: none;
    }
  }

  [data-type='country'],
  [data-type='prints'] {
    [data-section='more-from-artist'] &,
    [data-section='visually-similar'] &,
    [data-section='you-may-also-like'] & {
      display: none;
    }
  }
`
export const SponsoredPlacementWrapper = styled.figure`
  content-visibility: visible !important;
  [data-type='sponsored-artwork'],
  [data-type='sponsored-artist'] {
    width: 100%;
    max-width: 320px;
    padding: 20px;
    background-color: #f1f1f1;
    @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
      padding: 5px;
      max-width: 140px;
    }
    [data-type='artwork-image'],
    [data-type='artist-image'] {
      max-width: 280px;
      max-height: 280px;
      height: 100%;
      width: 100%;
      @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        width: 130px;
        height: 130px;
      }
    }
    [data-type='original'] {
      overflow: initial;
    }
    [data-type='artist-info'] {
      p[data-type='main'] {
        display: flex;
        justify-content: space-between;
        @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
          flex-direction: column;
        }
      }
      p[data-type='sub'] {
        font-size: 12px;
      }
    }
    [data-type='sponsored-info'] {
      font-style: italic;
      font-size: 14px;
      line-height: 24px;
      color: #666666;
      [data-type='main'] {
        display: flex;
        align-items: center;
        padding-top: 1px;
        @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
          font-size: 11px;
        }
      }
    }
    [data-type='sponsored-item-footer'] {
      line-height: 20px;
      letter-spacing: 0.5px;
      font-size: 14px;
      a {
        text-decoration: underline;
        @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
          font-size: 11px;
        }
      }
    }
  }
  [data-type='sponsored-artwork'] {
    [data-type='sponsored-info'] {
      @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        margin-top: 8px;
      }
    }
    [data-type='original'] {
      @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        width: 100%;
      }
    }
  }
  [data-type='sponsored-artist'] {
    [data-type='original'] {
      margin-top: 16px;
      @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        margin: 0;
        width: 100%;
      }
    }
    [data-type='info'] {
      margin: 0 0 4px;
      @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
        margin: 0;
      }
    }
    [data-type='artwork-info'] {
      p {
        line-height: 24px;
        @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
          overflow: initial;
          white-space: normal;
        }
      }
    }
    [data-type='artist-info'] {
      p[data-type='main'] {
        line-height: 24px;
        font-size: 17px;
        @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
          font-size: 14px;
          color: rgb(51, 51, 51);
        }
      }
      p[data-type='sub'] {
        line-height: 20px;
        font-size: 14px;
      }
    }
  }
`
export const InfoIcon = styled(Info)`
  height: 18px;
  width: 18px;
  margin-left: 8px;
  margin-top: -2px;
  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    height: 15px;
    width: 15px;
  }
`
export const ArtistImage = styled.div`
  position: relative;
  display: inline-block;
  a {
    display: flex;
  }
  picture {
    width: 100%;
    align-content: flex-start; /* Safari Bug */
    img {
      height: 100%;
      width: 100%;
      display: block;
      pointer-events: none;
      background: #cccccc;
      visibility: inherit;
    }
  }
`
export const SponsoredItemSkeleton = styled.div`
  max-width: 300px;
  height: 380px;
  overflow: hidden;
  position: relative;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    max-width: 140px;
    height: 220px;
  }

  // Animation
  animation-duration: 1.7s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  animation-name: placeholderAnimate;
  background: #f6f7f8;
  background: linear-gradient(to right, #eee 2%, #ddd 18%, #eee 33%);
  background-size: 1300px; // Animation Area

  .placeholder-content-item {
    width: 100%;
    height: 20px;
    position: absolute;
    background: #fff;
    z-index: 2;

    &:after,
    &:before {
      width: inherit;
      height: inherit;
      content: '';
      position: absolute;
    }

    &:nth-child(1) {
      top: 300px;
      left: 0;
      width: 100%;
      height: 10px;
    }

    &:nth-child(2) {
      top: 340px;
      left: 0;
      width: 100%;
      height: 10px;
    }

    &:nth-child(3) {
      top: 380px;
      left: 0;
      width: 100%;
      height: 10px;
    }
  }

  @keyframes placeholderAnimate {
    0% {
      background-position: -650px 0;
    }
    100% {
      background-position: 650px 0;
    }
  }
`
export const SponsoredTooltipContent = styled.div`
  padding: 8px 4px;
  font-style: normal;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  min-width: 150px;

  @media (max-width: ${(props) => props.theme.breakpoints[1]}) {
    min-width: 110px;
    align-items: flex-start;
  }

  p {
    color: #f1f1f1;
    font-size: 12px;
    line-height: 16px;
    width: 100%;
    overflow: initial;
    text-overflow: initial;
    white-space: normal;
  }
`
